import BookCover1 from "./book-cover-1.webp";
import DoubleBooks from "./double-books-1.webp";
import DoubleBooks2 from "./double-books-2.webp"; 
import DoubleBooks3 from "./double-books-3.webp";
import DoubleBook4 from "./double-books-4.webp";
import DoubleBook5 from "./double-books-5.webp";
import DoubleBook6 from "./double-books-6.webp";
import DoubleBook7 from "./double-books-7.webp";
import ThreeBooks from "./three-books.webp";
import ThreeBooks2 from "./three-books-2.webp";
import ThreeBooks3 from "./three-books-3.webp";
import ThreeBooks4 from "./three-books-4.webp";
import ThreeBooks5 from "./three-books-5.webp";
import ThreeBooks6 from "./three-books-6.webp";
import ThreeBooks7 from "./three-books-7.webp";
import ThreeBooks8 from "./three-books-8.webp";
import ThreeBooks9 from "./three-books-9.webp";
import ThreeBooks10 from "./three-books-10.webp";
import ThreeBooks11 from "./three-books-11.webp";
import ThreeBooks12 from "./three-books-12.webp";
import ThreeBooks13 from "./three-books-13.webp";
import ThreeBooks14 from "./three-books-14.webp";
import ThreeBooks15 from "./three-books-15.webp";
import ThreeBooks16 from "./three-books-16.webp";
import ThreeBooks17 from "./three-books-17.webp";
import ThreeBooks18 from "./three-books-18.webp";
import PenBook from "./pen-book.webp";
import BuyBook1 from "./buy-book-1.webp";
import BuyBook2 from "./buy-book-2.webp";
import BuyBook3 from "./buy-book-3.webp";
import BuyBook4 from "./buy-book-4.webp";
import BuyBook5 from "./buy-book-5.webp";
import BuyBook6 from "./buy-book-6.webp";
import HeroSlide1 from "./hero-slide-1.webp";
import HeroSlide2 from "./hero-slide-2.webp";
import HeroSlide3 from "./hero-slide-3.webp";
import HeroSlide4 from "./hero-slide-4.webp";
import HeroSlide5 from "./hero-slide-5.webp";
import HeroSlide6 from "./hero-slide-6.webp";
import HeroSlide7 from "./hero-slide-7.webp";
import HeroSlide8 from "./hero-slide-8.webp";
import HeroSlide9 from "./hero-slide-9.webp";
import HeroSlide10 from "./hero-slide-10.webp";
import HeroSlide11 from "./hero-slide-11.webp";
import HeroSlide12 from "./hero-slide-12.webp";
import HeroSlide13 from "./hero-slide-13.webp";
import HeroSlide14 from "./hero-slide-14.webp";
import HeroSlide15 from "./hero-slide-15.webp";
import HeroSlide16 from "./hero-slide-16.webp";
import HeroSlide17 from "./hero-slide-17.webp";
import HeroSlide18 from "./hero-slide-18.webp";
import CommonBooks1 from "./common-books-1.webp";
import CommonBooks2 from "./common-books-2.webp";
import CommonBooks3 from "./common-books-3.webp";
import CommonBooks4 from "./common-books-4.webp";
import CommonBooks5 from "./common-books-5.webp";
import CommonBooks6 from "./common-books-6.webp";
import CommonBooks7 from "./common-books-7.webp";
import CommonBooks8 from "./common-books-8.webp";
import CommonBooks9 from "./common-books-9.webp";
import CommonBooks10 from "./common-books-10.webp";

export {
  BookCover1,
  DoubleBooks,
  DoubleBooks2,
  DoubleBooks3,
  DoubleBook4,
  DoubleBook5,
  DoubleBook6,
  DoubleBook7,
  ThreeBooks,
  ThreeBooks2,
  ThreeBooks4,
  ThreeBooks5,
  ThreeBooks6,
  ThreeBooks7,
  ThreeBooks8,
  ThreeBooks9,
  ThreeBooks10,
  ThreeBooks11,
  ThreeBooks12,
  ThreeBooks13,
  ThreeBooks14,
  ThreeBooks15,
  ThreeBooks16,
  ThreeBooks17,
  ThreeBooks18,
  PenBook,
  BuyBook1,
  BuyBook2,
  BuyBook3,
  BuyBook4,
  BuyBook5,
  BuyBook6,
  ThreeBooks3,
  HeroSlide1,
  HeroSlide2,
  HeroSlide3,
  HeroSlide4,
  HeroSlide5,
  HeroSlide6,
  HeroSlide7,
  HeroSlide8,
  HeroSlide9,
  HeroSlide10,
  HeroSlide11,
  HeroSlide12,
  HeroSlide13,
  HeroSlide14,
  HeroSlide15,
  HeroSlide16,
  HeroSlide17,
  HeroSlide18,
  CommonBooks1,
  CommonBooks2,
  CommonBooks3,
  CommonBooks4,
  CommonBooks5,
  CommonBooks6,
  CommonBooks7,
  CommonBooks8,
  CommonBooks9,
  CommonBooks10,
};
